import api from './api';

export async function getPacientes(params) {
  const filtros = Object.fromEntries(
    Object.entries(params ?? {}).filter(([, value]) => String(value ?? '').trim() !== '')
  );

  const { data } = await api.get('/pacientes', {
    params: filtros,
  });

  return data ?? [];
}

export async function getPaciente(codPac) {
  if (!codPac) return null;
  const { data } = await api.get('/pacientes', {
    params: { codPac },
  });
  return data?.[0] ?? null;
}

export async function criarPaciente(paciente) {
  const { data } = await api.post('/paciente', paciente);
  return data;
}

export async function atualizarPaciente(paciente) {
  const { data } = await api.put('/pacientes', paciente);
  return data;
}
